<script>
  import { link } from "svelte-spa-router";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import { fade } from "svelte/transition";
  import config from "../../stores/config";
  import * as ls from "local-storage";
  import loadData from "../../utils/loadData";

  export let _id;
  export let title;
  export let fullName;
  export let tel;
  export let customerType;
  export let email;
  export let companyName;
  export let billingAddress;

  let authData = {
    headers: { authorization: ls.get("jwt") },
  };

  onMount(() => {});

  const dispatch = createEventDispatcher();

  const handleDelete = async () => {
    let resItem = await axios.get(
      `${$config.backendURL}/orders/with-customer/${_id}`,
      authData
    );

    let length = resItem.data.length;

    if (length > 0) {
      alert(
        `${fullName} is being used in the Orders database.\n\nYou cannot delete this record at the moment!`
      );
      return;
    }

    let confirmDelete = confirm(`Do you wish to delete ${fullName}?`);

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/customers/${_id}`, authData)
        .then((res) => {
          dispatch("delete");
          loadData();
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };
</script>

<div
  in:fade={{ duration: $config.f.time() }}
  class="tr border-b border-gray-100"
>
  <div style="min-width: 6.5rem; max-width: 6.5rem;" class="flex items-center">
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    <a
      href={`/customers/${_id}`}
      use:link
      class="text-base btn btn-green-outline"
    >
      <i class="fas fa-eye" />
    </a>
  </div>
  <div style="min-width: 17.5rem; max-width: 17.5rem;">
    {`${title} ${fullName}`}
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">{tel}</div>
  <div
    style="min-width: 15rem; max-width: 15rem; text-transform: lowercase !important;"
  >
    {email}
  </div>
  <!-- <div style="min-width: 7.5rem; max-width: 7.5rem;">
    {customerType}
  </div> -->

  <div style="min-width: 22.5rem; max-width: 22.5rem;">
    {billingAddress || ""}
  </div>
</div>

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
